(function () {
  'use strict';

  angular.module('sempraWebapp').factory('FacilityDetailsListenerViewModel', facilityDetailsListenerViewModelFactory);

  /** @ngInject */
  function facilityDetailsListenerViewModelFactory() {
    function FacilityDetailsListenerViewModel(listenerJson) {

      if (typeof listenerJson !== 'undefined') {
        this.refresh(listenerJson);
      }
    }

    FacilityDetailsListenerViewModel.prototype.destroy = function () {

    };

    FacilityDetailsListenerViewModel.prototype.refresh = function (listenerJson) {
      this.pointId = listenerJson.id;
      this.name = listenerJson.name;
      this.listenerStatus = 'offline';
      var that = this;
      listenerJson.feeds.forEach(function(status) {
            if (status.reference === "CONNECTION_ERROR" && status.currentValue === "0") {
                that.listenerStatus = 'online';
            }
      });
    };

    FacilityDetailsListenerViewModel.prototype.refreshFeed = function () {

    };

    return FacilityDetailsListenerViewModel;

  }
})();
